import React, {Component} from "react";
import { Modal, Button, Toast } from "antd-mobile";
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import EnrollServers from '../services/EnrollServers';
import Config from "../config";

@inject("enrollStore", "myEnrollStore")
@observer
class ManageDialog extends Component{
    state = {
        showVoucher: false,
        enrollList: [],
    };
    constructor(props){
        super(props); 
    };
    componentWillReceiveProps(props){     
        this.setState({showVoucher: props.showVoucher}, ()=>{
            if(props.showVoucher && Config.TOKEN && !this.state.enrollList.length){
                this.props.myEnrollStore.getMyEnroll(1, 100).then(res=>{   
                    if(res.sta == 0){
                        this.setState({enrollList: res.data});
                    }
                })
            }
        });   
    }  
    componentDidMount(){
        if(Config.TOKEN){
            this.props.myEnrollStore.getMyEnroll(1, 100).then(res=>{   
                if(res.sta == 0){
                    this.setState({enrollList: res.data});
                }
            })
        }       
    } 
    render(){
        let {detail} = this.props.enrollStore;
        let enrollList = this.state.enrollList.filter(item=>!(item.team_num > 0 && item.team_num > item.team_joins));
		return (
			<Modal title="我的凭证" visible={this.state.showVoucher} transparent={true} animationType="slide-up" popup className="vocher-data-dialog" onClose={()=>{
				this.props.close()		 
			}}>
                <div className="vocher-list">
                    {
                        enrollList.map((item, index)=>{                            
                            return (
                                <div className="vocher-items" key={index} onClick={()=>{
                                    // 待支付凭证尚未生成，支付完成后才能查看凭证详情。
                                    if(item.verified == 4){
                                        this.props.close();
                                        Toast.info('当前凭证待支付，请支付后再查看凭证');
                                    }else if(item.verified == -1){
                                        Toast.info('排队中不可查看凭证');
                                    }else if(detail.verify && (item.verified == 0 || item.verified == 2 || item.verified == 3)){
                                        this.props.close();
                                        setTimeout(() => {
                                            Modal.alert('暂不可查看凭证', '审核通过后即可查看，有疑问请留言咨询', [
                                                {
                                                    text: '去留言',
                                                    onPress: () => {
                                                        this.props.history.push('/message');
                                                    }
                                                },
                                                {
                                                    text: '我知道了'
                                                },
                                            ]);
                                        }, 0);
                                    }else{
                                        this.props.myEnrollStore.getEnrollCert(item.info_id).then(res=>{
                                            let {cert, records} = this.props.myEnrollStore;
                                            let params = {cert, records};
                                            sessionStorage.setItem('certInfo',JSON.stringify(params));                                         
                                            this.props.open();		                                            
                                        });    
                                    }
                                }}>
                                    <div>
                                        <div>{item.name}</div>
                                        <span className="cen-time">{EnrollServers.formatDate(item.join_time*1000, 'yyyy-MM-dd HH:mm')}</span>
                                    </div>
                                   { this.renderButton(item, detail) }                       
                                </div>
                            )
                        })
                    }             
                </div>				 
                {
                    !enrollList.length ? <div className="no-data">暂无凭证</div> : null                   
                }			 
				<Button className='cancel-btn' onClick={()=>{
					this.props.close() 				 
				}}>取消</Button>
			</Modal>
		)
    };
    renderButton(item, detail){       
        // 待支付状态优先展示，避免被审核或核销状态覆盖。
        if(item.verified == 4){
            return <span className="gray-text" style={{color: '#ff4a4a'}}>待支付</span>;
        }else if(item.verified == -1){
            return <span className="gray-text">排队中</span>;
        }else if(detail.verify && item.verified == 0){
            return <span className="gray-text">待审核</span>;
        }else if(detail.verify && item.verified == 2){
            return <span className="gray-text">退回</span>;
        }else if(detail.verify && item.verified == 3){
            return <span className="gray-text">驳回</span>;
        }else if(item.verify_cancel){
            return <span className="view-btn">已核销 ></span>   
        }else{
            return <span className="view-btn" style={{color: '#ff4a4a'}}>未核销 ></span> 
        }             
    };

}


export default withRouter(ManageDialog);
